<!-- components/GlobalTooltip.vue -->
<template>
  <Teleport to="body">
    <div
      ref="tooltipEl"
      class="global-tooltip"
      :class="{ 'global-tooltip--visible': visible }"
      :style="tooltipStyle"
      v-html="content"
    ></div>
  </Teleport>
</template>

<script>
let globalTooltipInstance = null

export default {
  name: 'GlobalTooltip',
  data() {
    return {
      visible: false,
      content: '',
      tooltipStyle: {
        left: '0px',
        top: '0px'
      },
      timer: null,
      targetElement: null,
      isHoveringTooltip: false
    }
  },
  mounted() {
    // Сохраняем экземпляр в глобальную переменную (не в реактивные объекты)
    globalTooltipInstance = this

    // Опционально: для отладки
    if (typeof window !== 'undefined') {
      window.__globalTooltip = this
    }

    this.$el.addEventListener('mouseenter', this.handleTooltipHover)
    this.$el.addEventListener('mouseleave', this.handleTooltipLeave)
  },
  beforeUnmount() {
    this.$el.removeEventListener('mouseenter', this.handleTooltipHover)
    this.$el.removeEventListener('mouseleave', this.handleTooltipLeave)
    this.hide()
    globalTooltipInstance = null
  },
  methods: {
    show(content, targetEl, event) {
      this.content = content
      this.targetElement = targetEl
      this.visible = true

      this.$nextTick(() => {
        this.positionTooltip(event)
      })
    },
    hide() {
      clearTimeout(this.timer)
      this.visible = false
      this.content = ''
      this.targetElement = null
    },
    scheduleShow(content, targetEl, event, delay = 380) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.show(content, targetEl, event)
      }, delay)
    },
    positionTooltip(event) {
      if (!this.visible || !this.$refs.tooltipEl) return

      const padding = 12
      const rect = this.$refs.tooltipEl.getBoundingClientRect()
      let x = event.clientX + 16
      let y = event.clientY + 16

      if (x + rect.width + padding > window.innerWidth) {
        x = event.clientX - rect.width - 16
      }
      if (y + rect.height + padding > window.innerHeight) {
        y = event.clientY - rect.height - 16
      }

      this.tooltipStyle.left = x + 'px'
      this.tooltipStyle.top = y + 'px'
    },
    handleTooltipHover() {
      this.isHoveringTooltip = true
      clearTimeout(this.timer)
    },
    handleTooltipLeave() {
      this.isHoveringTooltip = false
      this.hide()
    },
    attachToElement(element, contentGetter, options = {}) {
      const { delay = 380, showOnClick = false } = options

      const showTooltip = (event) => {
        const content = typeof contentGetter === 'function'
          ? contentGetter()
          : contentGetter
        this.scheduleShow(content, element, event, delay)
      }

      const hideTooltip = () => {
        if (!this.isHoveringTooltip) {
          this.hide()
        }
      }

      const positionTooltip = (event) => {
        this.positionTooltip(event)
      }

      if (showOnClick) {
        const clickHandler = (event) => {
          event.stopPropagation()
          if (this.visible && this.targetElement === element) {
            this.hide()
          } else {
            showTooltip(event)
          }
        }
        element.addEventListener('click', clickHandler)
        return {
          detach: () => {
            element.removeEventListener('click', clickHandler)
          }
        }
      } else {
        element.addEventListener('mouseenter', showTooltip)
        element.addEventListener('mousemove', positionTooltip)
        element.addEventListener('mouseleave', hideTooltip)
        return {
          detach: () => {
            element.removeEventListener('mouseenter', showTooltip)
            element.removeEventListener('mousemove', positionTooltip)
            element.removeEventListener('mouseleave', hideTooltip)
          }
        }
      }
    }
  }
}

// Экспортируем функцию для получения экземпляра
export function getTooltipInstance() {
  return globalTooltipInstance
}
</script>

<style lang="scss">
.global-tooltip {
  position: fixed;
  z-index: 99999;
  max-width: 420px;
  padding: 16px 18px;
  border-radius: 10px;
  background: #eef3f9;
  color: #1a2332;
  font-size: 13px;
  line-height: 1.5;
  box-shadow: 0 8px 30px rgba(0,0,0,0.3);
  pointer-events: auto;
  opacity: 0;
  transition: opacity 0.15s ease;

  &--visible {
    opacity: 1;
  }

  .tooltip__title {
    margin-bottom: 4px;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
  }

  .tooltip__sub {
    margin-bottom: 12px;
    color: #8b9bb5;
    font-size: 12px;
  }

  .tooltip__hint {
    margin-top: 10px;
    color: #9aabc0;
    font-size: 12px;
    opacity: 0.75;
  }

  .tooltip__group {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid rgba(255,255,255,0.06);

    &-label {
      margin-bottom: 6px;
      color: #8b9bb5;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }
  }

  .tooltip__row {
    display: flex;
    justify-content: space-between;
    padding: 3px 0;
    font-size: 12px;

    &-name {
      color: #d1dbe8;
    }

    &-val {
      color: #fff;
      font-weight: 600;
    }
  }
}
</style>